import { usePostHog } from "posthog-js/react";
import { useEffect, useMemo } from "react";

interface Organization {
  id: string;
  name: string;
}

interface AnalyticsUser {
  id: string;
  email: string;
  name: string;
  initials: string;
  currentOrganization?: Organization | null;
}

interface AnalyticsUserProviderProps {
  user: AnalyticsUser | null | undefined;
}

const AnalyticsUserProvider = ({ user }: AnalyticsUserProviderProps) => {
  const posthog = usePostHog();

  const analyticsUser = useMemo(() => {
    if (!user) return null;
    return {
      id: user.id,
      email: user.email,
      name: user.name,
      initials: user.initials,
      currentOrganization: user.currentOrganization,
    };
  }, [user]);

  useEffect(() => {
    if (!analyticsUser || !posthog) {
      return;
    }

    const organization = analyticsUser.currentOrganization;

    posthog.identify(analyticsUser.id, {
      email: analyticsUser.email,
      name: analyticsUser.name,
      initials: analyticsUser.initials,
    });

    if (organization) {
      posthog.group("organization", organization.id, {
        name: organization.name,
      });
    }
  }, [analyticsUser, posthog]);

  return null;
};

export { AnalyticsUserProvider };
export type { AnalyticsUser, Organization };
